
import { defineComponent } from "vue";
import navBar from "../../components/nav-bar/nav-bar.vue";
import ABOUT_SECTION_COMPONENTS from "./section-components";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Mousewheel, Pagination } from "swiper";
require("swiper/swiper.less");
require("swiper/components/pagination/pagination.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Pagination, Mousewheel]);
export default defineComponent({
  components: {
    navBar,
    ...SWIPER_COMPONENTS,
    ...ABOUT_SECTION_COMPONENTS,
  },

  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      screenWidth: document.body.clientWidth,
    };
  },

  mounted() {
    window.onresize = () => {
      let width = document.body.clientWidth;
      if ((this.screenWidth <= 1024 && width > 1024) || (this.screenWidth > 1024 && width <= 1024)) {
        location.reload();
      }
      this.screenWidth = width;
    };
  },
});
